function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import includes from 'lodash/includes';
import EBPropTypes from 'js-utils/prop-types';
import { getInitialValue } from '../inputs/utils';

var getAriaLabel = function getAriaLabel(display, value) {
  var label = null;

  if (!display) {
    label = value;
  }

  return label;
};

var getAriaLabelledBy = function getAriaLabelledBy(title, id) {
  var label = null;

  if (title) {
    label = id;
  }

  return label;
};

var RadioGroupTitle = function RadioGroupTitle(_ref) {
  var id = _ref.id,
      title = _ref.title;
  var component = null;

  if (title) {
    component = React.createElement("p", {
      className: "eds-text-bl",
      id: id
    }, title);
  }

  return component;
};

var getId = function getId(name, index) {
  return "radio-".concat(name, "-").concat(index);
};

var DisplayLabel = function DisplayLabel(_ref2) {
  var display = _ref2.display,
      name = _ref2.name,
      index = _ref2.index;
  var component = null;

  if (display) {
    component = React.createElement("label", {
      className: "eds-radio__label eds-radio__display-label",
      htmlFor: getId(name, index),
      "data-spec": "radio-display-label",
      "data-automation": "".concat(getId(name, index), "-label")
    }, display);
  }

  return component;
};
/**
 * Helper component for radio options
 * @prop {string} name - the name of the radio group
 * @prop {string} value - the value of the field if this option is checked
 * @prop {string} display - the text of option label displayed to user
 * @prop {boolean} inline - option to display the radio buttons inline
 * @prop {boolean} checked - radio input checked if true, false by default
 * @prop {boolean} disabled - radio input disabled if true, false by default
 * @prop {boolean} reversed - reverses display order to put the input on the right side
 * @prop {function} onChange - function to be invoked when radio button value changes
 * @example
 * // <RadioOption name="radio_group" value="option_01" display="Option 01" checked=true disabled=false />
 */


var RadioOption = function RadioOption(_ref3) {
  var index = _ref3.index,
      name = _ref3.name,
      value = _ref3.value,
      display = _ref3.display,
      checked = _ref3.checked,
      disabled = _ref3.disabled,
      reversed = _ref3.reversed,
      onChange = _ref3.onChange,
      onBlur = _ref3.onBlur,
      onFocus = _ref3.onFocus;
  return React.createElement("div", {
    className: classNames('eds-radio__option', {
      'eds-radio__option--reversed': reversed
    }),
    "data-spec": "radio-option-container"
  }, React.createElement("input", {
    type: "radio",
    id: getId(name, index),
    className: "eds-radio__input",
    name: name,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    "data-spec": "radio-button",
    "data-automation": getId(name, index),
    "aria-checked": checked,
    "aria-label": getAriaLabel(display, value)
  }), React.createElement("label", {
    className: "eds-radio__label eds-radio__delegate",
    htmlFor: getId(name, index),
    "data-spec": "radio-delegate"
  }), React.createElement(DisplayLabel, {
    display: display,
    name: name,
    index: index
  }));
};

var Radio =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Radio, _React$PureComponent);

  function Radio(props) {
    var _this;

    _classCallCheck(this, Radio);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Radio).call(this, props));
    var values = props.values,
        value = props.value,
        defaultValue = props.defaultValue;
    var initialValue;

    if (value || defaultValue) {
      initialValue = getInitialValue(value || defaultValue, values);
    }

    _this.state = {
      value: initialValue,
      active: false
    };
    return _this;
  }

  _createClass(Radio, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(_ref4) {
      var value = _ref4.value,
          values = _ref4.values;

      // Allows checking an existing radio button via props from a parent
      if (value) {
        this.setState({
          value: getInitialValue(value, values)
        });
      }
    }
  }, {
    key: "_handleChange",
    value: function _handleChange(e) {
      var value = e.target.value;
      this.setState({
        value: value
      });

      if (this.props.onChange) {
        this.props.onChange(value);
      }
    }
  }, {
    key: "_handleBlur",
    value: function _handleBlur() {
      this.setState({
        active: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(this.state.value);
      }
    }
  }, {
    key: "_handleFocus",
    value: function _handleFocus() {
      this.setState({
        active: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(this.state.value);
      }
    }
    /**
     * Build up the list of optionComponents and determine the checked
     * button in one iteration. We're determining this derived value here
     * instead of storing it in state.
     */

  }, {
    key: "_getOptionComponents",
    value: function _getOptionComponents() {
      var _this2 = this;

      var _this$props = this.props,
          name = _this$props.name,
          values = _this$props.values,
          disabledList = _this$props.disabledList,
          radioOptionReversed = _this$props.radioOptionReversed,
          renderRadioOptionContainer = _this$props.renderRadioOptionContainer;
      var value = this.state.value;
      var optionComponents = values.map(function (valueInfo, index) {
        var checked = valueInfo.value === value;
        var disabled = includes(disabledList, valueInfo.value);
        var radioOption = React.createElement(RadioOption, {
          index: index,
          name: name,
          value: valueInfo.value,
          display: valueInfo.display,
          checked: checked,
          disabled: disabled,
          onChange: _this2._handleChange.bind(_this2),
          onBlur: _this2._handleBlur.bind(_this2),
          onFocus: _this2._handleFocus.bind(_this2),
          reversed: radioOptionReversed,
          key: valueInfo.value
        });

        if (renderRadioOptionContainer) {
          return renderRadioOptionContainer(radioOption, valueInfo.value);
        }

        return radioOption;
      });
      return optionComponents;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          inline = _this$props2.inline,
          dataSpec = _this$props2['data-spec'],
          __containerClassName = _this$props2.__containerClassName,
          title = _this$props2.title;
      var active = this.state.active;
      var wrapperClassName = classNames('eds-radio', {
        'eds-radio--active': active,
        'eds-radio--inline': inline
      }, __containerClassName);
      return React.createElement("div", null, React.createElement(RadioGroupTitle, {
        id: id,
        title: title
      }), React.createElement("div", {
        className: wrapperClassName,
        "data-spec": dataSpec,
        role: "radiogroup",
        "aria-labelledby": getAriaLabelledBy(title, id)
      }, this._getOptionComponents()));
    }
  }]);

  return Radio;
}(React.PureComponent);

_defineProperty(Radio, "propTypes", {
  /**
   * Radio group name of the radio component
   */
  name: PropTypes.string.isRequired,

  /**
   * Array of formatted radio like data options
   * (value: The radio value & display: The radio displayed label)
   */
  values: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    display: PropTypes.node.isRequired
  })).isRequired,

  /**
  * Title of the radio group (used as the radio group label)
  */
  title: EBPropTypes.translation,

  /**
   * Current chosen radio button in the radio list
   */
  value: PropTypes.string,

  /**
   * Display the radio list inline
   */
  inline: PropTypes.bool,

  /**
   * Display the radio option in reverse order, this is done via flex-direction which does not change DOM order
   * for more details see: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Grid_Layout/CSS_Grid_Layout_and_Accessibility
   */
  radioOptionReversed: PropTypes.bool,

  /**
   * Render prop used to customize the style of each option
   */
  renderRadioOptionContainer: PropTypes.func,

  /**
   * ID of radio component's wrapper
   */
  id: PropTypes.string,

  /**
   * The value from values prop whose radio button should be checked by default
   */
  defaultValue: PropTypes.string,

  /**
   * List of values for disabled radio buttons
   */
  disabledList: PropTypes.arrayOf(PropTypes.string),

  /**
   * Class names for radio component wrapper
   */
  __containerClassName: PropTypes.string,

  /**
   * Function to be invoked when radio value changes
   */
  onChange: PropTypes.func,

  /**
   * Function To be invoked when radio button is blurred
   */
  onBlur: PropTypes.func,

  /**
   * Function to be invoked when radio button is blurred
   */
  onFocus: PropTypes.func,

  /**
   * Identifier for tests
   */
  'data-spec': PropTypes.string
});

_defineProperty(Radio, "defaultProps", {
  inline: false,
  radioOptionReversed: false,
  'data-spec': 'radio-wrapper'
});

export { Radio as default };